module.exports = __webpack_public_path__ + "static/media/login.d97190ee.svg";